const en_US = require('@drifthq/translations/languages/en-US.json')
const es_ES = require('@drifthq/translations/languages/es-ES.json')
const et_EE = require('@drifthq/translations/languages/et-EE.json')
const de_DE = require('@drifthq/translations/languages/de-DE.json')
const de_DE_formal = require('@drifthq/translations/languages/de-DE-formal.json')
const hi_IN = require('@drifthq/translations/languages/hi-IN.json')
const nl_NL = require('@drifthq/translations/languages/nl-NL.json')
const pt_PT = require('@drifthq/translations/languages/pt-PT.json')
const pt_BR = require('@drifthq/translations/languages/pt-BR.json')
const sv_SE = require('@drifthq/translations/languages/sv-SE.json')
const zh_CN = require('@drifthq/translations/languages/zh-CN.json')
const zh_HK = require('@drifthq/translations/languages/zh-HK.json')
const fr_FR = require('@drifthq/translations/languages/fr-FR.json')
const it_IT = require('@drifthq/translations/languages/it-IT.json')
const pl_PL = require('@drifthq/translations/languages/pl-PL.json')
const ru_RU = require('@drifthq/translations/languages/ru-RU.json')
const tr_TR = require('@drifthq/translations/languages/tr-TR.json')
const sl_SI = require('@drifthq/translations/languages/sl-SI.json')
const da_DK = require('@drifthq/translations/languages/da-DK.json')
const fi_FI = require('@drifthq/translations/languages/fi-FI.json')
const hr_HR = require('@drifthq/translations/languages/hr-HR.json')
const ko_KR = require('@drifthq/translations/languages/ko-KR.json')
const nb_NO = require('@drifthq/translations/languages/nb-NO.json')
const ro_RO = require('@drifthq/translations/languages/ro-RO.json')
const sr_SP = require('@drifthq/translations/languages/sr-SP.json')
const th_TH = require('@drifthq/translations/languages/th-TH.json')
const vi_VN = require('@drifthq/translations/languages/vi-VN.json')
const hu_HU = require('@drifthq/translations/languages/hu-HU.json')
const is_IS = require('@drifthq/translations/languages/is-IS.json')
const ja_JP = require('@drifthq/translations/languages/ja-JP.json')
const ka_GE = require('@drifthq/translations/languages/ka-GE.json')

export const messagesByLocale = {
  en: en_US,
  es: es_ES,
  et: et_EE,
  de: de_DE,
  'de-DE-formal': de_DE_formal,
  fr: fr_FR,
  it: it_IT,
  hi: hi_IN,
  hu: hu_HU,
  is: is_IS,
  nl: nl_NL,
  pt: pt_PT,
  'pt-BR': pt_BR,
  'pt-PT': pt_PT,
  sv: sv_SE,
  zh: zh_CN,
  'zh-HK': zh_HK,
  pl: pl_PL,
  ru: ru_RU,
  tr: tr_TR,
  sl: sl_SI,
  da: da_DK,
  fi: fi_FI,
  hr: hr_HR,
  ko: ko_KR,
  nb: nb_NO,
  ro: ro_RO,
  sr: sr_SP,
  th: th_TH,
  vi: vi_VN,
  ja: ja_JP,
  ka: ka_GE,
}

export const prefillLocale = {
  "en-US": "en",
  "es": "es",
  "et": "et",
  "de": "de",
  "fr": "fr",
  "it": "it",
  "hi": "hi",
  "hu": "hu",
  "is": "is",
  "nl": "nl",
  "pt": "pt",
  "pt-PT": "pt",
  "pt-BR": "pt-BR",
  "sv": "sv",
  "zh-CN": "zh",
  "zh-HK": "zh-HK",
  "pl": "pl",
  "ru": "ru",
  "tr": "tr",
  "sl": "sl",
  "da": "da",
  "fi": "fi",
  "hr": "hr",
  "ko": "ko",
  "nb": "nb",
  "ro": "ro",
  "sr": "sr",
  "th": "th",
  "vi": "vi",
  "ja": "ja",
  "ka": "ka",
}


// WEBPACK FOOTER //
// ./src/utils/translations.js